var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _BioExamResultsReceivedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import { sortBy } from "core/utils/sort";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import ApicryptMessageReceivedJournalEvent from "./apicrypt-message-received-journal-event";
import BioExamResult from "./bio-exam-result";
import BioExamResultsApprovedJournalEvent from "./bio-exam-results-approved-journal-event";
import { Summary } from "./journal-event";

//---- Automatically generated, don't update this part ----
let BioExamResultsReceivedJournalEvent = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("boolean", {
  allowNull: true
}), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = attr("boolean", {
  allowNull: true
}), _dec7 = attr("string"), _dec8 = attr("date"), _dec9 = attr("string"), _dec10 = attr("boolean", {
  allowNull: true
}), _dec11 = hasMany("bio-exam-results-approved-journal-event", {
  async: false,
  inverse: "bioExamResultsReceivedJournalEvent"
}), _dec12 = belongsTo("patient", {
  async: false,
  inverse: "bioExamResultsReceivedJournalEvents"
}), _dec13 = attr("bio-exam-result", {
  defaultValue() {
    return [];
  }
}), _dec14 = hasMany("apicrypt-message-received-journal-event", {
  async: false,
  inverse: "bioExamResultsReceivedJournalEvent"
}), _class = (_BioExamResultsReceivedJournalEvent = class BioExamResultsReceivedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "rawOru", _descriptor, this);
    _initializerDefineProperty(this, "oruId", _descriptor2, this);
    _initializerDefineProperty(this, "oruStatus", _descriptor3, this);
    _initializerDefineProperty(this, "isFromHprim", _descriptor4, this);
    _initializerDefineProperty(this, "isFromOru", _descriptor5, this);
    /**
     * Whether the bio exam has been processed or not.
     * Will be used only for bio exam results which come from Apicrypt.
     */
    _initializerDefineProperty(this, "isDraft", _descriptor6, this);
    /**
     * HLA result ID
     */
    _initializerDefineProperty(this, "hlaId", _descriptor7, this);
    /**
     * When the HLA consultation report has been edited
     */
    _initializerDefineProperty(this, "hlaCrDate", _descriptor8, this);
    _initializerDefineProperty(this, "lab", _descriptor9, this);
    _initializerDefineProperty(this, "normalized", _descriptor10, this);
    _initializerDefineProperty(this, "bioExamResultsApprovedJournalEvents", _descriptor11, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor12, this);
    /**
     * A list of Bio Exam Results, represented using an array of object.
     * Each object of the array is a structured object of type BioExamResult :
     * {
     *   code: "LOINC-630-4",
     *   value: "10",
     *   label: "ECBU",
     *   unit: "g/L"
     * }
     */
    _initializerDefineProperty(this, "results", _descriptor13, this);
    _initializerDefineProperty(this, "apicryptMessageReceivedJournalEvents", _descriptor14, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.bio-exam-results-received-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      oruStatus: validateInclusion({
        list: ["F", "P", "M", "I", "R", "C", "O", "D", "X"],
        allowBlank: true,
        description: intl.t("validations.bio-exam-results-received-journal-event.oru-status")
      })
    };
  }
  get lastApicryptMessage() {
    return this.apicryptMessageReceivedJournalEvents.toSorted(sortBy("createdAt")).at(-1);
  }

  /**
   * Find the BioExamResult with the given code
   */
  result(code) {
    return this.results.find(r => r.code === code);
  }
  hasAlertForCode(code) {
    if (!code || !this.isAlertingJournalEvent) return false;
    const normalizedCode = code.replace("LOINC-", "");
    return Boolean(this.alertTriggeredJournalEvents.find(alert => {
      return alert.code == normalizedCode;
    }));
  }
  get summary() {
    return Object.assign({}, super.summary, {
      forcIdentifier: {
        feature: "bio-results",
        component: "edition"
      }
    });
  }
  get showCorrection() {
    return this.oruStatus === "C" && this.validationStatus == "isDraft";
  }
  get isFromExternalSource() {
    return this.isFromHprim || this.isFromOru || Boolean(this.hlaId);
  }
  get sourceFileType() {
    if (this.isFromHprim) return "hprim";
    if (this.isFromOru) return "oru";
    return;
  }
  get validationStatus() {
    // if patient is not TLS (meaning he's "data only")
    if (!this.patient.tlsAgreed) {
      return "isPassivelyValidated";
    }

    // if patient is TLS but the JE was created before he accepted the TLS
    if (this.patient.tlsAgreedAt && this.patient.tlsAgreedAt > this.createdAt) {
      return "isPassivelyValidated";
    }
    return this.isDraft ? "isDraft" : "isValidated";
  }
  async approve() {
    this.isDraft = false;
    const results = this.results.map(res => {
      res.isDraft = false;
      return res;
    });
    this.results = results;
    this.save();
    await this.store.createRecord("bio-exam-results-approved-journal-event", {
      bioExamResultsReceivedJournalEvent: this,
      patient: this.patient,
      occurredAt: new Date()
    }).save();
  }
  get canEdit() {
    return !this.hlaId;
  }
}, _defineProperty(_BioExamResultsReceivedJournalEvent, "type", "bio-exam-results-received-journal-event"), _BioExamResultsReceivedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "rawOru", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "oruId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "oruStatus", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isFromHprim", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isFromOru", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isDraft", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hlaId", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hlaCrDate", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "lab", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "normalized", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "bioExamResultsApprovedJournalEvents", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "results", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "apicryptMessageReceivedJournalEvents", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BioExamResultsReceivedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.